import { ACCOUNT_MSG, CLOSE_GRACE_DAYS } from "@genbaryoku/contract";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { api, messageOf } from "../api.js";
import { setMe } from "../auth.js";
import { AuthCard, ErrorText } from "../components/ui.jsx";

/** 退会のメールの「元に戻す」リンクの先（026）。トークンを確かめて、そのままホームへ（ログインし直させない） */
export function ReopenPage() {
  const [sp] = useSearchParams();
  const token = sp.get("token") ?? "";
  const nav = useNavigate();
  const qc = useQueryClient();
  const [err, setErr] = useState<string | undefined>();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        const me = await api("POST", "/account/reopen", { token });
        await setMe(qc, me);
        nav("/home", { replace: true, state: { reopened: true } });
      } catch (e) {
        setErr(messageOf(e));
      }
    })();
  }, [token, nav, qc]);

  return (
    <AuthCard title="退会を取り消しています">
      {err ? (
        <>
          <ErrorText>{err}</ErrorText>
          <p className="hint">{ACCOUNT_MSG.accountClosed.replace("このメールアドレスは退会の手続き中です。", "")}。期限（{CLOSE_GRACE_DAYS}日）が切れていれば、データはもう消えています。</p>
          <div className="authlinks">
            <Link className="btn text" to="/login">ログイン画面へ（メールを再送できます）</Link>
            <Link className="btn text" to="/signup">新規会員登録</Link>
          </div>
        </>
      ) : (
        <p className="hint">少しお待ちください…</p>
      )}
    </AuthCard>
  );
}
